// 帳號 VMS 同步回放的主時鐘（MV.1，docs/mycam/mv-spec.md ①）：頁面一個時鐘、每格對齊它。
// Kinio 沒做多台同步（PLAY-03 只有規格：4 路、對齊 < 500 ms）；我們的做法：
//   每 250 ms 比對「主時鐘時間」與「這格現在播到的真實時間」：偏差 > 300 ms 用播放速度追、> 1.5 s 直接 seek。

export const ALIGN_RATE_US = 300_000;
export const ALIGN_SEEK_US = 1_500_000;
export const ALIGN_TICK_MS = 250;

export class SyncClock {
  private anchorPerfMs = 0;
  private anchorUs: number;
  private _rate = 1;
  private _playing = false;
  constructor(startUs: number, private now: () => number = () => performance.now()) {
    this.anchorUs = startUs;
  }
  get playing(): boolean { return this._playing; }
  get rate(): number { return this._rate; }
  /** 現在的主時鐘時間（µs，真實時間軸）。 */
  timeUs(): number {
    if (!this._playing) return this.anchorUs;
    return this.anchorUs + (this.now() - this.anchorPerfMs) * 1000 * this._rate;
  }
  private reanchor(us: number): void { this.anchorUs = us; this.anchorPerfMs = this.now(); }
  play(): void { if (!this._playing) { this.reanchor(this.timeUs()); this._playing = true; } }
  pause(): void { if (this._playing) { this.reanchor(this.timeUs()); this._playing = false; } }
  seek(us: number): void { this.reanchor(us); }
  setRate(r: number): void { this.reanchor(this.timeUs()); this._rate = r; }
}

export type AlignAction = { kind: 'none' } | { kind: 'rate'; rate: number } | { kind: 'seek'; toUs: number };

/** 這格現在播到 cellUs（真實時間）、主時鐘 clockUs、主時鐘速度 base → 要怎麼調。 */
export function alignDecision(cellUs: number, clockUs: number, base = 1): AlignAction {
  const diff = clockUs - cellUs; // > 0：這格落後
  const ad = Math.abs(diff);
  if (ad > ALIGN_SEEK_US) return { kind: 'seek', toUs: clockUs };
  if (ad > ALIGN_RATE_US) return { kind: 'rate', rate: base * (diff > 0 ? 1.1 : 0.9) };
  return { kind: 'none' };
}
